<div class="container single-view" id="view-retailer-attributes-definitions">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/retailer-attribute-definitions" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS.BTN_BACK_TO_RETAILER_ATTRIBUTES_DEFINITIONS' | translate }}</a>
      </div>
      <div class="switch-wr">
        @if (allowModifyRetailerAttribute) {
          <p-selectButton
            class="status-switch"
            [class.status-active]="stateInitialValue === true"
            [options]="stateOptions"
            optionLabel="displayLabel"
            optionValue="value"
            [allowEmpty]="false"
            [(ngModel)]="stateInitialValue"
            (onChange)="onStateChange($event)">
            <ng-template #item let-option>
              <span
                class="status-option"
                [attr.data-testid]="'btn-' + option.label">
                <i class="pi pi-check status-check" aria-hidden="true"></i>
                <span>{{ option.displayLabel }}</span>
              </span>
            </ng-template>
          </p-selectButton>
        }
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="retailerattribute-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.RETAILER_ATTRIBUTES_DEFINITIONS_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (retailerAttributesDefinition?.definitionCode) {
                  <span data-testid="retailerattribute-name">
                    {{ retailerAttributesDefinition.definitionCode | defaultValue }}
                  </span>
                }

                @if (retailerAttributesDefinition?.isActive) {
                  <span class="tag tag-green" data-testid="retailerAttributeDefinitionStatus-status">
                    {{ 'ENUMS.ACTIVE' | translate }}
                  </span>
                }

                @if (!retailerAttributesDefinition?.isActive) {
                  <span class="tag tag-red" data-testid="retailerAttributeDefinitionStatus-status">
                    {{ 'ENUMS.INACTIVE' | translate }}
                  </span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyRetailerAttribute) {
              <button data-testid="reatilerattributesdefinitions-edit-btn" class="btn primary-btn" (click)="goToEditRetailerAttributesDefinitions()">
                {{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.BTN_EDIT' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            @if (retailerAttributesDefinition) {
              <section class="row">
                <div class="col-12">
                  <h4 data-testid="retailerattribute-details">
                    {{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.DETAILS' | translate }}
                  </h4>

                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">

                  <dl class="details-grid">
                    <dt class="label grid-cols-1 pt-3">
                      {{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.ATTRIBUTE_CODE' | translate }}
                    </dt>
                    <dd class="value pt-3 pb-3">
                      {{ retailerAttributesDefinition.definitionCode | defaultValue }}
                    </dd>

                    <dt class="label grid-cols-1 pt-3">
                      {{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.DATA_TYPE' | translate }}
                    </dt>
                    <dd class="value pt-3 pb-3">
                      {{ retailerAttributesDefinition.retailerAttributeDataType | attributeDataTypePipe | defaultValue }}
                    </dd>

                    <dt class="label grid-cols-1 pt-3">
                      {{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.ALLOW_MULTIPLE_VALUES' | translate }}
                    </dt>
                    <dd class="value pt-3 pb-3">
                      {{ retailerAttributesDefinition.allowMultipleValues | friendlyBoolean }}
                    </dd>

                    <dt class="label grid-cols-1 pt-3">
                      {{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.CHANGES_OVER_TIME' | translate }}
                    </dt>
                    <dd class="value pt-3 pb-3">
                      {{ retailerAttributesDefinition.changesOverTime | friendlyBoolean }}
                    </dd>
                  </dl>
                </div>
              </section>
            }

            @if (
              retailerAttributesDefinition?.retailerAttributeDefinitionTranslations?.length &&
              retailerAttributesDefinition
            ) {
              <section class="row mt-5">
                <div class="col-12 mb-3">
                  <h4>{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.TRANSLATIONS' | translate }}</h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                </div>

                <div class="col-12">
                  <p-table data-testid="retailerattribute-definition-translations" [value]="retailerAttributesDefinition.retailerAttributeDefinitionTranslations ?? []">
                    <ng-template #header>
                      <tr>
                        <th>
                          <div class="header-wr">
                            <span class="col-name">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.LANGUAGE' | translate }}</span>
                          </div>
                        </th>
                        <th>
                          <div class="header-wr">
                            <span class="col-name">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.TRANSLATION' | translate }}</span>
                          </div>
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template #body let-translation>
                      <tr>
                        <td>
                          <span class="p-column-title">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.LANGUAGE' | translate }}:</span>
                          {{ translation.isoCode | languagePipe | defaultValue }}
                        </td>
                        <td>
                          <span class="p-column-title">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.TRANSLATION' | translate }}:</span>
                          {{ translation.translatedName | defaultValue }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </section>
            }

            @if (
              retailerAttributesDefinition?.retailerAttributeValues?.length &&
              retailerAttributesDefinition
            ) {
              <section class="row mt-5">

                <div class="col-12 mb-3">
                  <h4>{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.VALUES' | translate }}</h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                </div>

                <div class="col-12">
                  <p-table data-testid="retailerattribute-values" [value]="retailerAttributesDefinition.retailerAttributeValues ?? []">
                    <ng-template #header>
                      <tr>
                        <th>
                          <div class="header-wr">
                            <span class="col-name">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.VALUE_CODE' | translate }}</span>
                          </div>
                        </th>
                          <th>
                          <div class="header-wr">
                            <span class="col-name">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.IS_ACTIVE' | translate }}</span>
                          </div>
                        </th>
                        <th>
                          <div class="header-wr">
                            <span class="col-name">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.TRANSLATION' | translate }}</span>
                          </div>
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template #body let-value>
                      <tr>
                        <td>
                          <span class="p-column-title">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.VALUE_CODE' | translate }}:</span>
                          {{ value.valueCode | defaultValue }}
                        </td>
                          <td>
                          <span class="p-column-title">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.IS_ACTIVE' | translate }}:</span>
                          {{ value.isActive | friendlyBoolean }}
                        </td>
                        <td>
                          <span class="p-column-title">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_SINGLE_VIEW.TRANSLATION' | translate }}:</span>
                          @if (value.retailerAttributeValueTranslations?.length) {
                            @for (translation of value.retailerAttributeValueTranslations; track translation) {
                              <div>
                                <span class="strong">{{ translation.isoCode | languagePipe }}</span>: {{ translation.translatedValue | defaultValue }}&nbsp;
                              </div>
                            }
                          } @else {
                            {{ null | defaultValue }}
                          }
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </section>
            }
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Confirmation: state change -->
<p-confirmDialog key="confirm-state-change-dialog" (onHide)="stateInitialValue = retailerAttributesDefinition.isActive">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_CONFIRM_STATE_CHANGE' | translate }}</span>
  </ng-template>
  <ng-template pTemplate="message">
    <div class="flex flex-column align-items-center w-full gap-3">
      <p [innerHTML]="sanitizedConfirmMessage"></p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button id="btn-cancel-change" type="button" class="btn outline-btn" (click)="onCancelStateChange()">{{
      'MODALBOXES.BTN_CANCEL_STATE_UPDATE' | translate }}</button>
    <button id="btn-confirm-update" type="button" class="btn primary-btn" (click)="onConfirmStateChange()">{{
      'MODALBOXES.BTN_CONFIRM_STATE_UPDATE' | translate }}</button>
  </ng-template>
</p-confirmDialog>
